// extracted by mini-css-extract-plugin
export default {"custom_dialog":"CustomMchsPopup_custom_dialog__ATgnY","custom_dialog_close":"CustomMchsPopup_custom_dialog_close__6GAUY"};